export const CHECKOUT_ERROR_CODES = {
  brandSpecialBudgetExhausted: 'brand_special_budget_exhausted',
} as const;

export type CheckoutErrorCode =
  (typeof CHECKOUT_ERROR_CODES)[keyof typeof CHECKOUT_ERROR_CODES];

export interface CheckoutErrorDetails {
  code: CheckoutErrorCode;
  title?: string | null;
}
